module.exports = __webpack_public_path__ + "img/header.86c09d29.png";